import React from 'react';

import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';
import {
  COST_OF_LIVING,
  FORM_NAME,
  EVENT_TYPE,
} from '../../../../../lib/analytics-constants';
import {
  inputOnChange,
  CostOfLivingInput,
  inputOnBlur,
} from '../../../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const HouseholdIncomeInput = ({
  inputs,
  label = '',
  fullWidth = true,
  value,
  errorMessage,
  dispatch,
}: CostOfLivingInput): JSX.Element => {
  const placeholder = num.formatCurrency(inputs?.income);
  const error = Boolean(errorMessage);

  return (
    <InputMoney
      label={label}
      value={Number(value)}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onBlur={(e: OnChangeEvent) => {
        const bedrock = {
          eventType: EVENT_TYPE.INCOME_PRETAX_INCOME_UPDATED,
          was_prefilled: true,
          form_name: FORM_NAME.COST_OF_LIVING,
          valueFieldName: 'value_i',
          page_number: null,
          total_pages: null,
        };
        inputOnBlur({
          event: e,
          dispatch,
          // @ts-ignore error: not assignable to type '"value_i" | "value_n" | "value_s" | "value_ts"'
          bedrock,
          fieldName: 'income',
          calculator: COST_OF_LIVING,
          inputType: 'currency',
        });
      }}
      fullWidth={fullWidth}
      onChange={(e: OnChangeEvent) => {
        inputOnChange({
          event: e,
          dispatch,
          fieldName: 'income',
          calculator: COST_OF_LIVING,
          inputType: 'currency',
        });
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.costOfLivingCalculator?.inputs?.income,
  errorMessage: state?.validations?.income?.[0],
});

export default connect(mapStateToProps)(HouseholdIncomeInput);
